import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '@lingui/macro';
import Helmet from '../../components/SEO/Helmet';
import SharedSettingForm from './SharedSettingForm';

export default function SharedSettingNewPage() {
  const navigate = useNavigate();
  return (
    <>
      <Helmet
        title={t`New Shared Setting`}
        description={t`Create a new shared attribute mapping profile`}
      />
      <SharedSettingForm
        editingId={null}
        onBack={() => navigate('/toolkit/shared_settings')}
      />
    </>
  );
}
